import { CheckboxGroupInput, Edit, SimpleForm, TextInput } from 'react-admin';

import { USER_ROLES } from './userUtils';

export const UserEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput disabled={true} label="Meno" source="name" sx={{ width: '40em' }} />
      <TextInput disabled={true} label="Priezvisko" source="surname" sx={{ width: '40em' }} />
      <TextInput disabled={true} label="E-mail" required source="email" sx={{ width: '40em' }} />
      <TextInput disabled={true} label="Tel." source="phoneNumber" sx={{ width: '40em' }} />
      <TextInput disabled={true} label="Externé ID" source="externalId" sx={{ width: '40em' }} />
      <CheckboxGroupInput choices={USER_ROLES} fullWidth={false} label="Role" source="roles" />
    </SimpleForm>
  </Edit>
);
